import { render, staticRenderFns } from "./CompanyAccountList.vue?vue&type=template&id=3b938ba6&"
import script from "./CompanyAccountList.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports